import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ContactHero from './components/ContactHero';
import TrialProcess from './components/TrialProcess';
import TrialBookingForm from './components/TrialBookingForm';
import LocationSection from './components/LocationSection';
import ContactLineSection from './components/ContactLineSection';
import ContactFaq from './components/ContactFaq';
import SocialSection from './components/SocialSection';
import ContactForm from './components/ContactForm';

export default function Contact() {
  return (
    <div className="min-h-screen bg-[#faf8f5]">
      <Navbar />
      <main>
        <ContactHero />
        <ContactLineSection />
        <TrialProcess />
        <TrialBookingForm />
        <LocationSection />
        <SocialSection />
        <ContactFaq />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}